import React from "react";
import { Tabs } from "antd";

import { ReactComponent as AnalyticsIcon } from "../../assets/Icons/Sidebar_Analytics.svg";
import { ReactComponent as EquipmentIcon } from "../../assets/Icons/Sidebar_Equipment.svg";
import { ReactComponent as DragDrop } from "../../assets/Icons/Sidebar_DragDrop.svg";
import { ReactComponent as InspectionIcon } from "../../assets/Icons/Sidebar_Inspection.svg";
import { ReactComponent as HazardIcon } from "../../assets/Icons/Sidebar_HazardIcon.svg";

import PlaceholderImg from "../../assets/Images/ReportsDashboard.svg";

import InspectionsImg from "../../assets/Images/InspectionsMobile-01.png";
import Incidents from "../../assets/Images/HazardsIncidents-02.png";
import FormBuilderImg from "../../assets/Images/FormBuilder-01.png";
import Dashboard from "../../assets/Images/Dashboard.png";
import Assets from "../../assets/Images/AssetsView.png";

import { LearnMoreBtn } from "../LearnMoreBtn/LearnMoreBtn";
export function TabFeatures(props) {
  const items = [
    {
      key: "1",
      label: "Dashboards",
      children: (
        <div className="tabContent">
          <div className="tabContentInfo">
            <h4 className="smallSUbhead">Analytics</h4>
            <h2 className="emphasisHeadline">Dashboards</h2>
            <p className="bodyText">
              Get insights into your safety compliance with our comprehensive
              analytics and reporting tools. Track incidents, training progress,
              and more to ensure your facility meets all safety standards.
            </p>
            <LearnMoreBtn />
          </div>
          <div className="tabContentImage">
            <img
              src={Dashboard}
              alt="Analytics Dashboard"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      ),
      icon: (
        <AnalyticsIcon
          width={25}
          style={{ fill: "#037f4c", position: "relative", top: "4px" }}
        />
      ),
    },
    {
      key: "2",
      label: "From Builder",
      children: (
        <div className="tabContent">
          <div className="tabContentInfo">
            <h4 className="smallSUbhead">Custom Forms Made Simple</h4>
            <h2 className="emphasisHeadline"> Drag n' Drop Form Builder</h2>
            <p className="bodyText">
              Create the forms your facility needs — fast. Build custom forms
              for inspections, emergency response plans, orientations, and more
              with our intuitive drag-and-drop builder. Choose from yes/no,
              dropdowns, text fields, and more. Submit forms for approval or
              start using them right away. With built-in version control, you’ll
              never lose track of changes.
            </p>
            <LearnMoreBtn />
          </div>
          <div className="tabContentImage">
            <img
              src={FormBuilderImg}
              alt="Analytics Dashboard"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      ),
      icon: (
        <DragDrop
          width={25}
          style={{ fill: "#784bd1", position: "relative", top: "4px" }}
        />
      ),
    },
    {
      key: "3",
      label: "Hazards & Incidents",
      children: (
        <div className="tabContent">
          <div className="tabContentInfo">
            <h4 className="smallSUbhead">No paperwork. No delays.</h4>
            <h2 className="emphasisHeadline">
              Report Hazards and Incidents Instantly
            </h2>
            <p className="bodyText">
              Whether it’s a near-miss or a major incident, your team can report
              it right away using their phone or tablet. Quick, easy, and always
              documented.
            </p>
            <LearnMoreBtn />
          </div>
          <div className="tabContentImage">
            <img
              src={Incidents}
              alt="Analytics Dashboard"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      ),
      icon: (
        <HazardIcon
          width={25}
          style={{ fill: "#FDAB3D", position: "relative", top: "4px" }}
        />
      ),
    },

    {
      key: "4",
      label: "Inspections",
      children: (
        <div className="tabContent">
          <div className="tabContentInfo">
            <h4 className="smallSUbhead">Any Device, Any Where</h4>
            <h2 className="emphasisHeadline">Inspections Made Easy</h2>
            <p className="bodyText">
              Each piece of equipment has a QR code — scan it with a phone to
              complete pre-use inspections, access safety documents, or perform
              maintenance tasks on the fly.
            </p>
            <LearnMoreBtn />
          </div>
          <div className="tabContentImage">
            <img
              src={InspectionsImg}
              alt="Analytics Dashboard"
              style={{ maxWidth: "100%" }}
            />
          </div>
        </div>
      ),
      icon: (
        <InspectionIcon
          width={22}
          style={{ fill: "#FF158A", position: "relative", top: "4px" }}
        />
      ),
    },
    {
      key: "5",
      label: "Assets",
      children: (
        <div className="tabContent">
          <div className="tabContentInfo">
            <h4 className="smallSUbhead">Track & Maintain</h4>
            <h2 className="emphasisHeadline">Equipment & Asset Management</h2>
            <p className="bodyText">
              Everything you need to track and maintain your gear. Organize
              equipment by category and manage it from a single screen. Create
              maintenance tasks and set automated reminders so nothing gets
              missed. Generate QR code labels for each asset — scan with a phone
              to complete pre-use inspections, access manuals, view SDS sheets,
              and perform maintenance right on the spot.
            </p>
            <LearnMoreBtn />
          </div>
          <div className="tabContentImage">
            <img src={Assets} alt="Analytics Dashboard" />
          </div>
        </div>
      ),
      icon: (
        <EquipmentIcon
          width={25}
          style={{ fill: "#ffcc00", position: "relative", top: "4px" }}
        />
      ),
    },
  ];

  return (
    <>
      <section className="tabFeaturesCotnainer">
        <div className="tabFeaturesHeader">
          <h3 className="mediumHeadline">Total Control, Zero Confusion</h3>

          <p className="bodyText textCentre">
            From employee tracking to inspections and hazard reports, Alpaca
            gives you a powerful, visual command center. Build custom forms,
            assign training, manage assets, and stay ahead of what matters —
            without the paper trail or guesswork.
          </p>
        </div>
        <Tabs
          className="tabFeatures"
          defaultActiveKey="1"
          items={items}
          style={{ width: "100%" }}
          centered
          tabBarStyle={{ fontSize: "16pt", userSelect: "none" }}
        />
      </section>

      <section className="tabFeaturesMobile">
        {items.map((item) => (
          <div className="tabMobileItem" key={item.key}>
            <div className="tabContentInfo">
              <h4 className="smallSUbhead">
                {
                  item.children.props.children[0].props.children[0].props
                    .children
                }
              </h4>
              <h2 className="emphasisHeadline">
                {
                  item.children.props.children[0].props.children[1].props
                    .children
                }
              </h2>
              <p className="bodyText">
                {
                  item.children.props.children[0].props.children[2].props
                    .children
                }
              </p>
              <LearnMoreBtn />
            </div>
            <div className="tabContentImage">
              <img
                src={item.children.props.children[1].props.children.props.src}
                alt={item.label}
              />
            </div>
          </div>
        ))}
      </section>
    </>
  );
}
